import { render } from "./teaResearch.vue?vue&type=template&id=24f28486&scoped=true"
import script from "./teaResearch.vue?vue&type=script&lang=js"
export * from "./teaResearch.vue?vue&type=script&lang=js"

import "./teaResearch.vue?vue&type=style&index=0&id=24f28486&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f28486"]])

export default __exports__